<template>

    <div class="row">

        <div class="col-10 text-center mx-auto mb-4">  
            <p class="welcome-3 colortextmyfo1">Définissez vos objectifs</p>
            <div class="row justify-content-center dashboardstyle">
                <table class="text-center py-0 px-4" style="margin:auto; width:100%;">
                    <thead class="" style="font-size: 14px; color: #3867D6; width:100%;">
                        <tr style="width:100%;">
                            <th class="pb-1" scope="col" style="width: 20%; vertical-align: middle; font-size:12px;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-cash-stack svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M14 3H1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1h-1z"/><path fill-rule="evenodd" d="M15 5H1v8h14V5zM1 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H1z"/><path d="M13 5a2 2 0 0 0 2 2V5h-2zM3 5a2 2 0 0 1-2 2V5h2zm10 8a2 2 0 0 1 2-2v2h-2zM3 13a2 2 0 0 0-2-2v2h2zm7-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/></svg>Valeur du bien (€)</th>
                            <th class="pb-1" scope="col" style="width: 20%; vertical-align: middle; font-size:12px;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-smartwatch svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M14 5h.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H14V5z"/><path fill-rule="evenodd" d="M8.5 4.5A.5.5 0 0 1 9 5v3.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1 0-1h2V5a.5.5 0 0 1 .5-.5z"/><path fill-rule="evenodd" d="M4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zm0 1A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7z"/><path d="M4 2.05v-.383C4 .747 4.746 0 5.667 0h4.666C11.253 0 12 .746 12 1.667v.383a2.512 2.512 0 0 0-.5-.05h-7c-.171 0-.338.017-.5.05zm0 11.9c.162.033.329.05.5.05h7c.171 0 .338-.017.5-.05v.383c0 .92-.746 1.667-1.667 1.667H5.667C4.747 16 4 15.254 4 14.333v-.383z"/></svg>Horizon de temps (années)</th>
                            <th class="pb-1" scope="col" style="width: 20%; vertical-align: middle; font-size:12px;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-download svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>Votre apport (€)</th>
                            <th class="pb-1" scope="col" style="width: 20%; vertical-align: middle; font-size:12px;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-percent svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/></svg>Taux de l'emprunt (%)</th>
                            <th class="pb-1" scope="col" style="width: 20%; vertical-align: middle; font-size:12px;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-house-door svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.646 1.146a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 .146.354v7a.5.5 0 0 1-.5.5H9.5a.5.5 0 0 1-.5-.5v-4H7v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .146-.354l6-6zM2.5 7.707V14H6v-4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4h3.5V7.707L8 2.207l-5.5 5.5z"/><path fill-rule="evenodd" d="M13 2.5V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/></svg>Loyer</th>                   
                        </tr>
                    </thead>
                    <tbody  class="paragraphe text-center align-content-center" style="font-size: 12px; width:100%;">        
                        <tr class="">
                            <td class="text-justify p-2" style="width: 20%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"
                                    step="1000"    
                                    min="0"           
                                    :name="flat_value"             
                                    v-model="flat_value"
                                    @change="onDataChange">  
                            </td>
                            <td class="text-justify p-2" style="width:20%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"     
                                    step="1"    
                                    min="4"           
                                    :name="time_horizon"             
                                    v-model="time_horizon"
                                    @change="onDataChange">  
                            </td> 
                            <td class="text-justify p-2" style="width:20%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"     
                                    step="100"    
                                    min="0"           
                                    :name="equity_amount"             
                                    v-model="equity_amount"
                                    @change="onDataChange">  
                            </td>
                            <td class="text-justify p-2" style="width:20%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"     
                                    step="0.001"    
                                    min="0"           
                                    :name="loan_rate"             
                                    v-model="loan_rate"
                                    @change="onDataChange">  
                            </td>
                            <td class="text-justify p-2" style="width:20%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"     
                                    step="100"    
                                    min="0"           
                                    :name="rent"             
                                    v-model="rent"
                                    @change="onDataChange">  
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>                    
        </div>

        <div class="col-10 mx-auto justify-content-center">
            <div class="row justify-content-center dashboardstyle">
                <canvas ref="chart"></canvas>
            </div>
        </div>

        <div class="col-8 mx-auto text-center pt-4">  
            <p class="welcome-3 colortextmyfo1">Retour sur investissement après taxes et frais</p>
            <div class="row justify-content-center dashboardstyle py-2">
                <table class="table table-responsive text-center table-borderless" style="margin:auto;">
                    <thead class="paragraphe" style="font-size: 14px; flex: 0 0 auto; color: #3867D6;">
                        <tr style="display: table; table-layout: fixed; width:100%">
                            <th scope="col" style="vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5); width: 33.33%; text-align:right;">Régime</th>
                            <th scope="col" style="vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5); width: 33.33%;">NPV</th>
                            <th scope="col" style="vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5); width: 33.33%;">IRR</th>
                        </tr>
                    </thead>
                    <tbody class="paragraphe text-center align-content-center" style="font-size: 12px; max-height: 600px; overflow: scroll; flex: 1 1 auto; display: block; overflow-y: auto; overflow-x: hidden;">        
                        <tr style="display: table; width:100%">
                            <td class="text-right" style="vertical-align: middle; width: 33.33%;" >
                                Location vide - régime réel
                            </td> 
                            <td class="text-center" style="vertical-align: middle; width: 33.33%;" >
                                {{new Intl.NumberFormat().format(Math.round(npv_real,1))}} €
                            </td> 
                            <td class="text-center" style="vertical-align: middle; width: 33.33%;" >
                                {{new Intl.NumberFormat().format(Math.round(irr_real,1))}} %
                            </td>  
                        </tr>  
                        <tr style="display: table; width:100%">
                            <td class="text-right" style="vertical-align: middle; width: 33.33%;" >
                                Location vide - régime micro foncier
                            </td> 
                            <td class="text-center" style="vertical-align: middle; width: 33.33%;" >
                                {{new Intl.NumberFormat().format(Math.round(npv_micro,1))}} €
                            </td> 
                            <td class="text-center" style="vertical-align: middle; width: 33.33%;" >
                                {{new Intl.NumberFormat().format(Math.round(irr_micro,1))}} %
                            </td>  
                        </tr>   
                        <tr style="display: table; width:100%">
                            <td class="text-right" style="vertical-align: middle; width: 33.33%;" >
                                Location meublée
                            </td> 
                            <td class="text-center" style="vertical-align: middle; width: 33.33%;" >
                                {{new Intl.NumberFormat().format(Math.round(npv_furnished,1))}} €
                            </td> 
                            <td class="text-center" style="vertical-align: middle; width: 33.33%;" >
                                {{new Intl.NumberFormat().format(Math.round(irr_furnished,1))}} %
                            </td>  
                        </tr>     
                    </tbody>
                </table>
            </div>                     
        </div>

        <div class="col-8 mx-auto text-center pt-4">  
            <p class="welcome-3 colortextmyfo1">Calculs intermédiaires</p>
            <div class="row justify-content-center dashboardstyle py-2">
                <table class="text-center py-0 px-4" style="margin:auto; width:100%;">
                    <thead class="paragraphe" style="font-size: 14px; color: #3867D6; width:100%;">
                        <tr>
                            <th class="p-2" scope="col" style="width: 33.33%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214, 0.5);">Montant de l'emprunt</th>
                            <th class="p-2" scope="col" style="width: 33.33%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214, 0.5);">Coût annuel de l'emprunt sur la période (PMT)</th>
                            <th class="p-2" scope="col" style="width: 33.33%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214, 0.5);">Frais de notaire</th>
                        </tr>
                    </thead>
                    <tbody class="paragraphe text-center align-content-center" style="font-size: 12px; width:100%;">        
                        <tr>
                            <td class="text-center p-3" style="width:33.33%;vertical-align: middle;" >
                                {{new Intl.NumberFormat().format(loan_amount)}} €
                            </td>
                            <td class="text-center p-3" style="width:33.33%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{new Intl.NumberFormat().format(-pmt)}} €
                            </td>
                            <td class="text-center p-3" style="width:33.33%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{new Intl.NumberFormat().format(notary_fee)}} €
                            </td> 
                        </tr>
                    </tbody>
                </table>
            </div>                     
        </div> 
        
        <div class="col-8 text-center pt-4 mx-auto mb-4">  
            <p class="welcome-3 colortextmyfo1">Hypothèses</p>
            <div class="row justify-content-center dashboardstyle py-2">
                <table class="table text-center table-borderless py-0 px-4" style="margin:auto; width:100%;">
                    <thead class="paragraphe" style="font-size: 14px; flex: 0 0 auto; color: #3867D6;">
                        <tr style="">
                            <th style="width: 50%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);"></th>
                            <th class="text-center" style="width: 10%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Montant</th>
                            <th class="text-center" style="width: 40%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);"></th>       
                        </tr>
                    </thead>
                    <tbody  class="paragraphe text-center align-content-center" style="font-size: 12px; max-height: 600px; overflow: scroll; overflow-y: auto; overflow-x: hidden;">        
                        <tr>
                            <td class="text-right" style="width:50%;vertical-align: middle;">Taxes :</td> 
                            <td class="text-center" style="width:10%;vertical-align: middle;">
                                {{tax*100}} %
                            </td>
                            <td style="width:40%; border-top: 1px solid rgba(56, 103, 214,0.2);"></td>
                        </tr> 
                        <tr>
                            <td class="text-right" style="width:50%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Inflaton annuelle :</td> 
                            <td class="text-center" style="width:10%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">{{inflation_rate*100}} %</td>
                            <td style="width:40%; border-top: 1px solid rgba(56, 103, 214,0.2);"></td>
                        </tr>  
                        <tr>
                            <td class="text-right" style="width:50%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Taux Banque Centrale :</td> 
                            <td class="text-center" style="width:10%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                {{risk_free*100}} %
                            </td>
                            <td style="width:40%; border-top: 1px solid rgba(56, 103, 214,0.2);"></td>
                        </tr>
                        <tr>
                            <td class="text-right" style="width:50%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Taux d'inoccupation :</td> 
                            <td class="text-center" style="width:10%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                {{vacancy_rate*100}} %
                            </td>
                            <td style="width:40%; border-top: 1px solid rgba(56, 103, 214,0.2);"></td>
                        </tr> 
                        <tr>
                            <td class="text-right" style="width:50%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Coûts maintenance (% du loyer) :</td> 
                            <td class="text-center" style="width:10%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                {{repair_cost*100}} %
                            </td>
                            <td style="width:40%; border-top: 1px solid rgba(56, 103, 214,0.2);"></td>
                        </tr>
                        <tr>
                            <td class="text-right" style="width:50%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Taxe d'habitation (% du loyer) :</td> 
                            <td class="text-center" style="width:10%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                {{council_tax*100}} %
                            </td>
                            <td style="width:40%; border-top: 1px solid rgba(56, 103, 214,0.2);"></td>
                        </tr>  
                    </tbody>
                </table>
            </div>                     
        </div> 

    </div>

</template>

<script>

    import {Chart} from 'chart.js';
    export default{

        data() {
            return {                                               
                testGraph: null,
                equity_amount: 15000,             
                time_horizon: 10,
                loan_rate: 1.8,
                vacancy_rate: 0.1,
                inflation_rate: 0.02,
                risk_free: 0,
                tax: 0.3,
                repair_cost: 0.1,
                council_tax: 0.08,
                rent: 400,
                flat_value: 80000,
                npv_real: 0, 
                irr_real: 0,
                npv_micro: 0, 
                irr_micro: 0,
                npv_furnished: 0, 
                irr_furnished: 0,
                loan_amount: 0,
                pmt: 0,
                notary_fee: 0,                    
            }                      
        },  


        mounted() {    
            var ctx = this.$refs.chart.getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, 0, 400);

            gradient.addColorStop(0, 'rgba(56, 103, 214,0.3)');
            gradient.addColorStop(0.5, 'rgba(56, 103, 214,0.1)');
            gradient.addColorStop(1, 'rgba(56, 103, 214, 0)');

            this.testGraph = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Location vide - régime réel',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .5)',
                            fontFamily: "Poppins",
                        },
                        {
                            label: 'Location vide - régime micro',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .8)',
                            fontFamily: "Poppins",
                        },
                        {
                            label: 'Location meublée',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .10)',
                            fontFamily: "Poppins",
                        },
                    ],
                },
    
                options: {
                    scales: {
                        tooltips: {
                            titleFontFamily: "Poppins",
                            titleFontStyle: 'normal',
                            bodyFontFamily: 'Poppins'
                        },
                        legend: {
                            fontFamily: "Poppins"
                        },
                        yAxes:[
                            {
                                stacked: false,
                                ticks: {
                                    beginAtZero: false,
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(169,169,169)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                            }
                        ],
                        xAxes:[
                            {
                                ticks: {
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(56, 103, 214)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                                stacked: false,
                            }
                        ]
                    }
                }
            });
            this.onDataChange();
        },
                
        methods: {  
            onDataChange(){    
                // calcul ici data_av et data_ct en fonction de this.amount, this.time_horizon et this.performance

                var labels = [];
                var data_cashflow_real = [];
                var data_cashflow_micro = [];
                var data_cashflow_furnished = [];
                var pmt = 0;
                var loan_rate = 1.8;
                var npv_real = 0;
                var irr_real = 0;
                var npv_micro = 0;
                var irr_micro = 0;
                var npv_furnished = 0;
                var irr_furnished = 0;
                var loan_amount = 0;
                var flat_value = 0;

                this.npv = 0;
                this.loan_amount = parseFloat(this.flat_value) - parseFloat(this.equity_amount);
                this.pmt = Math.round(PMT(parseFloat(this.loan_rate/100)/12, 12*parseFloat(this.time_horizon), this.loan_amount, 0, 0)*12,1);

                this.running_cost = (this.council_tax+this.repair_cost)*(parseFloat(this.rent)*12)

                this.notary_fee = this.flat_value*0.08;

                labels[0] = "Année " + (parseFloat(0));
                data_cashflow_real[0] = -(parseFloat(this.flat_value) + this.notary_fee) +this.loan_amount;
                this.npv_real +=  data_cashflow_real[0]/(Math.pow((1+(this.inflation_rate+this.risk_free)),0));

                data_cashflow_micro[0] = -(parseFloat(this.flat_value) + this.notary_fee) +this.loan_amount;
                this.npv_micro +=  data_cashflow_micro[0]/(Math.pow((1+(this.inflation_rate+this.risk_free)),0));

                data_cashflow_furnished[0] = -(parseFloat(this.flat_value) + this.notary_fee) +this.loan_amount;
                this.npv_furnished +=  data_cashflow_furnished[0]/(Math.pow((1+(this.inflation_rate+this.risk_free)),0));

                for (let year = 1; year < this.time_horizon; year++)
                {
                    labels[year] = "Année " + (parseFloat(year));
                    //first and last year are specific
                    data_cashflow_real[year] = Math.round((parseFloat(this.rent)*12)*(1-this.vacancy_rate)*(1-this.tax) - this.running_cost*Math.pow((1+this.inflation_rate),year) + this.pmt,0);
                    data_cashflow_micro[year] = Math.round((parseFloat(this.rent)*12)*(1-this.vacancy_rate)*(1-this.tax*0.7) - this.running_cost*Math.pow((1+this.inflation_rate),year) + this.pmt,0);
                    data_cashflow_furnished[year] = Math.round((parseFloat(this.rent)*12)*(1-this.vacancy_rate)*(1-this.tax*0.5) - this.running_cost*Math.pow((1+this.inflation_rate),year) + this.pmt,0);
                        

                    this.npv_real +=  data_cashflow_real[year]/(Math.pow((1+(this.inflation_rate+this.risk_free)),year));
                    this.npv_micro +=  data_cashflow_micro[year]/(Math.pow((1+(this.inflation_rate+this.risk_free)),year));
                    this.npv_furnished +=  data_cashflow_furnished[year]/(Math.pow((1+(this.inflation_rate+this.risk_free)),year));
                }
                labels[parseFloat(this.time_horizon)] = "Année " + (parseFloat(this.time_horizon));

                data_cashflow_real[parseFloat(this.time_horizon)] = Math.round(parseFloat(this.flat_value)*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) + (parseFloat(this.rent)*12)*(1-this.vacancy_rate)*(1-this.tax) - this.running_cost*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) + this.pmt - (parseFloat(this.flat_value)*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) -parseFloat(this.flat_value))*this.tax,0);
                this.npv_real +=  data_cashflow_real[parseFloat(this.time_horizon)]/(Math.pow((1+(this.inflation_rate+this.risk_free)),parseFloat(this.time_horizon)));
                this.irr_real = IRRCalc(data_cashflow_real);

                data_cashflow_micro[parseFloat(this.time_horizon)] = Math.round(parseFloat(this.flat_value)*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) + (parseFloat(this.rent)*12)*(1-this.vacancy_rate)*(1-this.tax*0.7) - this.running_cost*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) + this.pmt - (parseFloat(this.flat_value)*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) -parseFloat(this.flat_value))*this.tax,0);
                this.npv_micro +=  data_cashflow_micro[parseFloat(this.time_horizon)]/(Math.pow((1+(this.inflation_rate+this.risk_free)),parseFloat(this.time_horizon)));
                this.irr_micro = IRRCalc(data_cashflow_micro);

                data_cashflow_furnished[parseFloat(this.time_horizon)] = Math.round(parseFloat(this.flat_value)*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) + (parseFloat(this.rent)*12)*(1-this.vacancy_rate)*(1-this.tax*0.5) - this.running_cost*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) + this.pmt - (parseFloat(this.flat_value)*Math.pow((1+this.inflation_rate),parseFloat(this.time_horizon)) -parseFloat(this.flat_value))*this.tax,0);
                this.npv_furnished +=  data_cashflow_furnished[parseFloat(this.time_horizon)]/(Math.pow((1+(this.inflation_rate+this.risk_free)),parseFloat(this.time_horizon)));
                this.irr_furnished = IRRCalc(data_cashflow_furnished);
                
                this.testGraph.data.labels = labels;
                this.testGraph.data.datasets[0].data = data_cashflow_real;
                this.testGraph.data.datasets[1].data = data_cashflow_micro;
                this.testGraph.data.datasets[2].data = data_cashflow_furnished;
                this.testGraph.update();
            },            
        }
        
    }  
    function IRRCalc(CArray) {

        var min = 0.0;
        var max = 1.0;
        var NPV = 0;
        do {
            var guest = (min + max) / 2;
            NPV = 0;
            for (var j=0; j<CArray.length; j++) {
                NPV += CArray[j]/Math.pow((1+guest),j);
            }
            if (NPV > 0) {
            min = guest;
            }
            else {
            max = guest;
            }
        } while(Math.abs(NPV) > 0.000001);
        return guest * 100;
    }
    

    function PMT(ir, np, pv, fv, type) {
    /*
     * ir   - interest rate per month
     * np   - number of periods (months)
     * pv   - present value
     * fv   - future value
     * type - when the payments are due:
     *        0: end of the period, e.g. end of month (default)
     *        1: beginning of period
     */
        var pmt, pvif;

        fv || (fv = 0);
        type || (type = 0);

        if (ir === 0)
            return -(pv + fv)/np;

        pvif = Math.pow(1 + ir, np);
        pmt = - ir * pv * (pvif + fv) / (pvif - 1);

        if (type === 1)
            pmt /= (1 + ir);

        return pmt;
    }  
         
</script>